export const LEVEL4 = 'level4';
export const LEVEL4_CATEGORIES_FETCH = 'LEVEL4_CATEGORIES_FETCH';
export const LEVEL4_CONDITIONS_FETCH = 'LEVEL4_CONDITIONS_FETCH';
export const LEVEL4_BOARDS_FETCH = 'LEVEL4_BOARDS_FETCH';
export const LEVEL4_BOARD_FETCH = 'LEVEL4_BOARD_FETCH';
export const LEVEL4_HOTSPOTS_FETCH = 'LEVEL4_HOTSPOTS_FETCH';
export const LEVEL4_VEHICLE_DATA = 'LEVEL4_VEHICLE_DATA';
export const LEVEL4_SEARCH_DATA = 'LEVEL4_SEARCH_DATA';
export const LEVEL4_SEARCH_DATA_CURRENT = 'LEVEL4_SEARCH_DATA_CURRENT';
export const LEVEL4_CATEGORIES_PATH_PUSH = 'LEVEL4_CATEGORIES_PATH_PUSH';
export const LEVEL4_CATEGORIES_PATH_EMPTY = 'LEVEL4_CATEGORIES_PATH_EMPTY';
export const LEVEL4_VEHICLE_CURRENT_FILTERS = 'LEVEL4_VEHICLE_CURRENT_FILTERS';

export const vehicleFiltersBasicTypes = [
  {
    name: 'brand',
    label: 'Brand',
    valueName: 'brandId',
  },
  {
    name: 'category',
    label: 'Category',
    valueName: 'category',
  },
  {
    name: 'catalog',
    label: 'Catalog',
    valueName: 'catalog',
  },
];

export const vehicleFiltersVehicleTypes = [
  {
    name: 'type',
    label: 'Type',
    valueName: 'type',
    isMotor: true,
    isAuto: false,
  },
  {
    name: 'serie',
    label: 'Serie',
    valueName: 'serie',
    isMotor: true,
    isAuto: true,
  },
  {
    name: 'body',
    label: 'Body',
    valueName: 'bodyId',
    isMotor: false,
    isAuto: true,
  },
  {
    name: 'model',
    label: 'Model',
    valueName: 'modelId',
    isMotor: true,
    isAuto: true,
  },
  {
    name: 'engine',
    label: 'Engine',
    valueName: 'engineId',
    isMotor: true,
    isAuto: true,
  },
  {
    name: 'version',
    label: 'Version',
    valueName: 'versionList',
    isArray: true,
    isMotor: true,
    isAuto: true,
  },
  {
    name: 'steering',
    label: 'Steering',
    valueName: 'steeringId',
    isMotor: false,
    isAuto: true,
  },
  {
    name: 'transmission',
    label: 'Transmission',
    valueName: 'transmissionId',
    isMotor: false,
    isAuto: true,
  },
  {
    name: 'year',
    label: 'Year',
    valueName: 'year',
    isMotor: true,
    isAuto: true,
  },
  {
    name: 'month',
    label: 'Month',
    valueName: 'month',
    isMotor: true,
    isAuto: true,
  },
];
